import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Recent projects/spaces the user has interacted with (expanded, filed into,
// searched-to). Stored in localStorage so the list survives across sessions.
// We keep at most MAX entries, sorted most-recent-first; older entries are
// pruned silently.

const MAX = 30;
const STORAGE_KEY = 'prism-recent-containers-v1';

interface RecentEntry {
  id: string;
  openedAt: number; // epoch ms
}

interface RecentState {
  recent: RecentEntry[];
  touch: (id: string) => void;
  clear: () => void;
}

export const useRecentProjectsStore = create<RecentState>()(
  persist(
    (set) => ({
      recent: [],
      touch: (id) =>
        set((s) => {
          const filtered = s.recent.filter((e) => e.id !== id);
          const next = [{ id, openedAt: Date.now() }, ...filtered].slice(0, MAX);
          return { recent: next };
        }),
      clear: () => set({ recent: [] }),
    }),
    { name: STORAGE_KEY },
  ),
);
